import axios from '@/plugins/axios'

export default {
    optimize(data) {
        return axios({
            url: '/optimize',
            method: 'post',
            data
        })
    },
    getImgsCompressedByLog(data) {
        let {limit=50, id=0, type=[], status=[], page=0 } = data
        return axios({
            url: `/compress-images/by-log/${id}`,
            method: 'get',
            params: {
                page,
                limit,
                filters: {type, status}
            }
        })
    },
    getDetailImage(query) {
        let { id = 0 } = query
        return axios({
            url: `/compress-images/detail/${id}`,
            method: 'get'
        })
    },
    restoreImage(data) {
        let { id = 0 } = data
        return axios({
            url: `/compress-images/restore/${id}`,
            method: 'post'
        })
    },
    getTotalImages() {
        return axios({
            url: '/compress-images/total-image',
            method: 'get'
        })
    },
    getOverview() {
        return axios({
            url: '/optimize/overview',
            method: 'get'
        })
    },
    hideConfirmRestore() {
        return axios({
            url: '/compress-images/restore/hide-confirm',
            method: 'post'
        })
    },
    stopOptimizeImages() {
        return axios({
            url: '/compress-images/process/stop',
            method: 'post'
        })
    },
    checkNewOptimize() {
        return axios({
            url: `/optimize/check-new-optimize`,
            method: 'get'
        })
    },
    getProcess() {
        return axios({
            url: '/optimize/process',
            method: 'get'
        })
    },
    getSettingsTheme() {
        return axios({
            url: '/optimize-theme/settings',
            method: 'get'
        })
    },
    stopOptimizeTheme() {
        return axios({
            url: '/optimize-theme/process/stop',
            method: 'post'
        })
    },
    getThemeByLog(data) {
        let {limit=20, id=0, page=0 } = data
        return axios({
            url: `/optimize-theme/by-log/${id}`,
            method: 'get',
            params: {
                page,
                limit,
            }
        })
    },
    getAutoSettings() {
        return axios({
            url: '/optimize/auto-settings',
            method: 'get'
        })
    },
    saveAutoSettings(data) {
        let { optimize_image = null, optimize_theme = null, publish_theme = null } = data

        return axios({
            url: '/optimize/auto-settings',
            method: 'post',
            params: {
                optimize_image,
                optimize_theme,
                publish_theme
            }
        })
    },
    removeDuplicateTheme() {
        return axios({
            url: '/optimize-theme/remove-duplicate',
            method: 'post'
        })
    },
    publishChange() {
        return axios({
            url: '/optimize-theme/publish-change',
            method: 'post'
        })
    },
    removeCode() {
        return axios({
            url: '/optimize-theme/remove-code',
            method: 'post'
        })
    },
    updateTooltip() {
        return axios({
            url: '/optimize/update-tooltip-auto-settings',
            method: 'post'
        })
    }
}
